import React, { Component } from "react";
import { Modal, Form } from "react-bootstrap";
import CustomButton from "../../../../components/buttons/customButton";

class AssignTagModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUserData: [],
            searchTags: "",
            changedFields: new Set(),
            loading: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { show, waMessageContacts = [], selectedUser } = this.props;

        if (prevProps.show !== show) {
            if (show) {
                const tagDetails = waMessageContacts.find(
                    (item) => item.wa_contact_id === selectedUser
                );
                let selectedData = [];
                if (tagDetails?.tag_id != null) {
                    selectedData = tagDetails.tag_id.split(",").map(Number);
                }
                this.setState({ selectedUserData: selectedData, searchTags: "", changedFields: new Set() });
            } else {
                this.setState({ selectedUserData: [], searchTags: "", changedFields: new Set() });
            }
        }
    }

    handleSelectedTags(e, tagId) {
        const checked = e.target.checked;
        this.setState((prev) => {
            const selected = checked
                ? [...prev.selectedUserData, tagId]
                : prev.selectedUserData.filter((id) => id !== tagId);
            const changedFields = new Set(prev.changedFields);
            changedFields.add("selectedUserData");
            return { selectedUserData: selected, changedFields };
        });
    }

    handleSelectAll(e) {
        const checked = e.target.checked;
        const { getTags = [] } = this.props;
        const { searchTags } = this.state;
        const filteredTags = getTags.filter((tag) =>
            tag.tag_name.toLowerCase().includes(searchTags.toLowerCase())
        );
        this.setState((prev) => {
            const allIds = filteredTags.map((tag) => tag.id);
            const selected = checked
                ? Array.from(new Set([...prev.selectedUserData, ...allIds]))
                : prev.selectedUserData.filter((id) => !allIds.includes(id));
            const changedFields = new Set(prev.changedFields);
            changedFields.add("selectedUserData");
            return { selectedUserData: selected, changedFields };
        });
    }

    async handleSubmit(e) {
        e.preventDefault();
        const { changedFields, selectedUserData } = this.state;
        const { selectedUser, handleClose, onUpdateTags } = this.props;

        if (!changedFields || changedFields.size === 0) {
            console.log("No changes to update");
            setTimeout(() => handleClose(), 1000);
            return;
        }

        this.setState({ loading: true });
        try {
            if (onUpdateTags) {
                await onUpdateTags({
                    wa_contact_id: selectedUser,
                    tag_id: selectedUserData.toString(),
                });
                console.log("Tags updated successfully");
                handleClose();
            }
        } catch {
            console.error("Server error. Please try again.");
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { show, handleClose, getTags = [] } = this.props;
        const { selectedUserData, searchTags, loading } = this.state;

        const filteredTags = getTags.filter((tag) =>
            tag.tag_name.toLowerCase().includes(searchTags.toLowerCase())
        );

        return (
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header style={{ backgroundColor: "var(--primary)", color: "#fff", borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                    <Modal.Title style={{ fontSize: "1.2rem" }}>Update Tag</Modal.Title>
                    <button
                        type="button"
                        className="close"
                        style={{ color: "#fff", opacity: 1 }}
                        onClick={handleClose}
                    >
                        <span>&times;</span>
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-3">
                        <Form.Control
                            size="sm"
                            placeholder="Search tags..."
                            value={searchTags}
                            onChange={(e) => this.setState({ searchTags: e.target.value })}
                        />
                    </div>

                    <div className="mb-2">
                        <Form.Check
                            type="checkbox"
                            label="Select All"
                            checked={filteredTags.every((tag) => selectedUserData.includes(tag.id)) && filteredTags.length > 0}
                            onChange={(e) => this.handleSelectAll(e)}
                        />
                    </div>

                    <div style={{ maxHeight: 300, overflowY: "auto", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                        {filteredTags.map((item) => {
                            const exist = selectedUserData.includes(item.id);
                            return (
                                <Form.Check
                                    key={item.id}
                                    type="checkbox"
                                    label={item.tag_name}
                                    checked={exist}
                                    onChange={(e) => this.handleSelectedTags(e, item.id)}
                                />
                            );
                        })}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <CustomButton
                        status={loading ? "loading" : "idle"}
                        onClick={(e) => this.handleSubmit(e)}
                        label="Update"
                        loadingLabel="Submitting.."
                    />
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AssignTagModal;
